import React from 'react'
import { openAgentLoginSubAccountSelector } from './helper/openAgentLoginSubAccountSelector'
import CustomIcon from '@/components/CustomIcon'
import styles from './index.less'
import { getTerminaDomain } from '@/utils/terminal'
import ReplicableNumber from '@/components/ReplicableNumber'
import classNames from 'classnames'
import { Tooltip } from 'antd'
import Action from '@/components/Action'

const SUPPLIER_ORIGIN = getTerminaDomain(window.PROJECT_CONFIG.supplierTerminalName)

const ActionIcon = Action(CustomIcon)
interface AgentLoginProps {
    coId: string
    redirect?: string
    coName: string
    coNameExtra?: string
}
const AgentLogin = ({ coId, coName, coNameExtra, redirect }: AgentLoginProps) => {
    const params = {
        coId,
        redirect: redirect || `${SUPPLIER_ORIGIN}/dashboard`
    }
    return (
        <div className={styles.nameBox}>
            <Tooltip overlay={null} title={coName}>
                <span className={classNames(styles.name, 'ellipsis-2-line')}>{coName}</span>
            </Tooltip>
            {coNameExtra}
            <ReplicableNumber className={styles.copy} dataSource={coName} color="#1890FF" hideDataSource />

            <ActionIcon
                className={styles.icon}
                type="icon-yewuyuan"
                customizeLoading
                onClick={() => openAgentLoginSubAccountSelector(params)}
            />
        </div>
    )
}

export default AgentLogin
